import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import ProjectsS2 from '../../components/ProjectsS2'
import Logo from '../../images/logo.svg'
import { useFetch } from '../../hooks/useFetch';
import { fetchprojects } from '../../api/api';
import { useTranslation } from 'react-i18next';


const ProjectPage = () => {
    const {
        data: projects,
        error: projectsError,
        isLoading: projectsIsloading,
    } = useFetch(["projects"], fetchprojects);
    const { t } = useTranslation();
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={t('pageTitles.project')} pagesub={t('pageTitles.project')} />
            <ProjectsS2 projects={projects?.data?.data} projectsIsloading={projectsIsloading} projectsError={projectsError} />
            <Footer ftClass={'wpo-site-footer-s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default ProjectPage;
